@if (discount(); as discount) {

  <span class="">
    <span [id]="describedby()" class="block text-right">
      <span class="h5 mb-0">{{ calculateTotal() | currency: 'EUR' }}</span>
      <span class="pl-1 h6 mb-0">{{ discount.oneTime ? 'eenmalig' : '/maand' }}</span>
    </span>

    <span class="block text-sm">
      @if (discount.oneTime ) {
        <em>{{ 'common.discount.discount-line-one-time.description' | translate:{
            price: price() | currency: 'EUR',
            priceType: (isOneTimePayment() ? 'eenmalig' : '/maand')
        } }} </em>
      } @else {
        <em>{{ 'common.discount.discount-line.description' | translate:{
            periodAmount: discount.period,
            period: ('common.period.' + discount.periodFormat | translate),
            price: price() | currency: 'EUR',
            priceType: (isOneTimePayment() ? 'eenmalig' : '/maand')
          } }}
        </em>
      }
    </span>
  </span>
}
